import { BaseComponent } from "../../../base/base.component";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { AppComponent } from "../../../app.component";
import { Router } from "@angular/router";
import { GenericService } from "../../../../crossconcern/services/generic.services";
import { Location } from "@angular/common";
import {
    ADD_PATH,
    BACKOFFICE_PATH,
    NURSERY_PATH
} from "../../../../crossconcern/utilities/properties/path.property";
import { NURSERY_SELECTOR } from "../../../../crossconcern/utilities/properties/selector.property";
import { Subscription } from "rxjs";
import { AlertUtils } from "../../../../crossconcern/utilities/utils/alert.utils";

@Component({
    selector: NURSERY_SELECTOR,
    templateUrl: "./nursery.component.html"
})
export class NurseryComponent extends BaseComponent implements OnInit, OnDestroy {
    public onNewCalledSubscription: Subscription;

    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        protected genericService: GenericService,
        protected location: Location,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
    }

    public ngOnInit() {
        this.subscribeGenericServices();
    }

    public ngOnDestroy() {
        this.unsubscribeServices();
    }

    private subscribeGenericServices() {
        this.onNewCalledSubscription = this.genericService.onNewCalled.subscribe(() => {
            this.goToRoute(BACKOFFICE_PATH + NURSERY_PATH + "/" + ADD_PATH);
        });
    }

    private unsubscribeServices() {
        this.onNewCalledSubscription.unsubscribe();
    }

}
